import { Environment } from "@/types/environment";

const development: Environment = {
  api: {
    enterprise: "CGMP",
    baseUri: "https://api-qa.pedagioeletronicosemparar.com.br/webapi",
    baseUriAuth: "https://api-qa.pedagioeletronicosemparar.com.br",
    apiKeyAuth: "hJ8zGyqgOJ4RHCZpyWqzX3DiwxovviEz9Wb7utPN",
    companyIdentification: "CGMP",
    channel: "16",
    automaticChannel: "16",
    userIdentification: "ffap",
    merchantDefinedInformation: {
      channel: "APP-RecargaPreManual",
    },
    cybersource: {
      orgId: "1snn5n9w",
      merchantId: "semparar_br",
    },
    prefix: "ff-",
    hashKey: "lBDmE8znV1RFngzBfPEE7splx6Uj7i2O",
    loginVersion: "v1",
    app: "PagueFF",
    scrapersBaseUri: "https://staging.apisemparar.io",
    scrapersApiKey: "cbfd08dd-1102-47b1-a046-3567917ded7b",
    userProduct: {
      baseUri: "https://homolog.apisemparar.com.br",
      path: "/home-app/v1/init/userproduct",
      pageSize: 15,
      skipPrefix: true,
      appversion: "20.0.0",
      apiKey: "lOSk1plngG81nSXYqsZx09cJviRzvMG66rksYiD4",
    },
  },
  pci: {
    url: "https://cyptgw-hml.fleetcor.com.br",
    key: "85de3840bc3840e837cf6313c0917a5cc030f9adab0afdd793a5cdbc08ab3357",
  },
  recaptcha: {
    siteKey: "6Le60qMrAAAAAFWEDb3P14KuOMxYqV3EziFbO6NK",
  },
};

export default development;
